import { Injectable, ResolvedReflectiveProvider as RRP } from '@angular/core';

import {
  DialogRef,
  Maybe,
  Overlay,
  DROP_IN_TYPE,
  Modal as Modal_
} from 'angular2-modal';

import { JSNativePresetBuilder } from './presets/js-native-preset';
export class Modal extends Modal_ {
/**
 * @param {?} overlay
 */
constructor(overlay: Overlay) {
    super(overlay);
  }
/**
 * @return {?}
 */
alert(): JSNativePresetBuilder {
    return new JSNativePresetBuilder(this, DROP_IN_TYPE.alert);
  }
/**
 * @return {?}
 */
prompt(): JSNativePresetBuilder {
    return new JSNativePresetBuilder(this, DROP_IN_TYPE.prompt);
  }
/**
 * @return {?}
 */
confirm(): JSNativePresetBuilder {
    return new JSNativePresetBuilder(this, DROP_IN_TYPE.confirm);
  }
/**
 * @param {?} dialogRef
 * @param {?} type
 * @param {?=} bindings
 * @return {?}
 */
protected create(dialogRef: DialogRef<any>,
                   type: any,
                   bindings?: RRP[]): Maybe<DialogRef<any>> {
    return dialogRef;
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Overlay, },
];
}

function Modal_tsickle_Closure_declarations() {
/** @type {?} */
Modal.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Modal.ctorParameters;
}





interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
